<!--Section: Magazine v.3-->
<section class="magazine-section my-5  text-center">

    <div class="col-xl-6  col-lg-8 col-md-12 mb-lg-0 mb-5 mx-auto">
        <!-- Section heading -->
        <h2 class="h1-responsive color-primary my-5">Art des Leistungsangebotes</h2>
        <!-- Section description -->
        <p class="px-5 mb-5 pb-3 lead text-dark  mx-auto text-left">Das Angebot von eo ipso richtet sich primär an Familien,
        Kinder und Jugendliche, sowie junge Erwachsene. Im Rahmen der ambulanten Jugendhilfe bietet eo ipso den
        Adressaten die Klärung der aktuellen Lebenssituation und lösungsorientierte Perspektiv- und
        Ressourcenentwicklung, mit dem Ziel Lebenswirklichkeit zukünftig gelingend selbsttätig zu gestalten, an.
    </p>
    <p class=" px-5 mb-5 pb-3 lead text-dark mx-auto text-left">Es liegt uns am Herzen, eine ehrliche und ethisch
            anspruchsvolle Arbeit zu leisten, geprägt durch Sachverstand, Intuition und Wertschätzung.
        </p>


        <h5 class="color-primary">Das Team von eo ipso bietet:</h5>

        <div class="col-xl-8  col-lg-12 col-md-12 mb-lg-0 mb-5 mx-auto">
            <ul class="text-dark text-left">

                <li>Hilfen zur Erziehung nach §§ 27 ff SGB VIII</li>
                <li>Klärungsaufträge und Diagnostik</li>
                <li>Einschätzung & Beratung bzgl. Kinderschutz § 8a SGB VIII</li>
                <li>Aufsuchende Familientherapie</li>
                <li>Pädagogische Kunsttherapie</li>
                <li>Kreative Kinder- und Jugendtherapie</li>
                <li>Tiergestützte Pädagogik</li>
                <li>Beratung und Begleitung von Pflegefamilien und Pflegefachdiensten</li>
                <li>Trennungs- und Scheidungsberatung</li>
                <li>Paartherapie</li>
                <li>Begleitete Umgänge § 18 SGB VIII</li>
            </ul>
        </div>
    </div>


    <app-gallery></app-gallery>

</section>
<!--Section: Magazine v.3-->









 